// extracted by mini-css-extract-plugin
export default {"shadow":"profile_shadow__3AyyV","border":"profile_border__E2r1w","wrapper":"profile_wrapper__0Esmf"};